import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
import PETROLSIDE from "../../../assets/images/Dualcabmain.jpg";
import { useNavigate } from "react-router";
import PETROLModels from "../../../components/NZComponent/NzPetrol/PETROLModels";
import HighLevelSpecs from "../../../components/NZComponent/NzPetrol/HighLevelSpecs";
import NZNZPetrolGregFarrier from "../../../components/NZComponent/NzPetrol/NZNZPetrolGregFarrier";
import NZElectricaTV from "../../../components/NZComponent/NzPetrol/NZElectricaTV";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import NZElectricDualModels from "../../../components/NZComponent/NzElectricDualMotor/NZElectricDualModels";
import NZElectricDualSpec from "../../../components/NZComponent/NzElectricDualMotor/NZElectricDualSpec";
import E_Logo from "../../../assets/images/E_Logo.png";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import SEOMetadata from "../../../components/SEOMetadata";
import { seoConfig } from "../../../config/seoConfig";
import NZElectricDualFAQ from "../../../components/NZComponent/NzElectricDualMotor/NZElectricDualFAQ";

const NzElectricDualMotor = () => {
  let navigate = useNavigate();
  const textRef = useRef(null);
  const eRef = useRef(null);
  const [offset, setOffset] = useState(0);
  const [spacing, setSpacing] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      if (textRef.current && eRef.current) {
        const textSize = window.getComputedStyle(textRef.current).fontSize;
        const textHeight = parseFloat(textSize); // Convert to number
        setOffset(textHeight * 0.1); // Adjust dynamically based on font size
        const eWidth = eRef.current.getBoundingClientRect().width;
        setSpacing(eWidth * 0.98);
      }
    };

    // Initial calculation
    handleResize();

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const seoData = seoConfig.nz.electricDualMotor;

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img
            src={HomeIcon}
            alt="HomeIcon"
            className="cursor-pointer"
            onClick={() => navigate("/")}
          />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">{`Electric Dual Motor / Dual Cabin`}</div>
        </div>
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-0 md:gap-0">
          <div className="w-full">
            <img
              src={PETROLSIDE}
              alt="eTuatara 6 seat electric double cab dual motor utility vehicle"
              className="w-full h-[300px] sm:h-[400px] md:h-[600px] lg:h-[520px] xl:h-[720px] object-cover"
            />
          </div>
          <div className="flex flex-col justify-center text-center 
px-6 md:px-12 lg:px-16 xl:px-20 py-8 md:py-24 gap-6 lg:gap-10 xl:py-24 lg:py-8 lg:px-8 xl:px-24">

            <h1
              className="text-white kuunari-bold  text-center
  text-[20px] 
  md:text-[40px] 
  lg:text-[29px]  
  xl:text-[60px]  
  leading-[32px]
  md:leading-[42px] 
  lg:leading-[48px]
  xl:leading-[62px]
  mb-[20px]"
              style={{ textShadow: "2px 4px 6px #000000" }}
            >
              <span
                ref={textRef}
                className="relative inline-block"
                style={{ paddingLeft: `${spacing}px` }}
              >
                <span
                  ref={eRef}
                  style={{ bottom: `${offset}px` }}
                  className="font-Dancing font-extrabold text-[#7bc25c] inline-block absolute left-0 
      text-[22px] md:text-[52px] lg:text-[78px] text-center"
                >
                  e
                </span>
                Tuatara
              </span>{" "}
              6 Seat Electric Double Cab Dual Motor Utility Vehicle
            </h1>
            <p className="text-center text-[#666] text-[16px] md:text-[18px] leading-[28px]">
              The eTuatara 6 Seat Electric Double Cab Dual Motor utility vehicle is designed
              for transporting people safely and comfortably across demanding terrain.
              Featuring dual electric motors, a high-capacity battery, and a spacious cabin,
              it delivers powerful performance with low running costs and minimal
              maintenance.
            </p>
            <div className="text-center flex items-center justify-center flex-wrap">
              <button
                className="bg-[#6FBF4A] text-white px-6 py-3 font-semibold uppercase hover:opacity-90 transition"
                onClick={() => navigate("/nz/ContactUs")}
              >
                CONTACT US
              </button>
            </div>
          </div>

        </div>
        <div className="bg-white py-[80px] px-6">
          <div className="max-w-[1160px] mx-auto">

            {/* H2 */}
            <h2 className="text-center kuunari-bold text-[26px] md:text-[36px] mb-[40px]">
              About the eTuatara 6 Seat Dual Motor Electric UTV
            </h2>

            {/* Intro */}
            <p className="text-gray-600 text-[16px] md:text-[18px] leading-[28px] text-center max-w-[900px] mx-auto mb-[50px]">
              Our newest addition to the eTuatara family is a 6-seat double cab UTV designed
              as a go-anywhere people mover. Its innovative dual-motor configuration places
              one motor on each axle, eliminating the need for transmissions or drive shafts.
            </p>

            {/* GRID */}
            <div className="grid md:grid-cols-3 gap-[40px]">

              {/* Section 1 */}
              <div>
                <h3 className="text-[20px] font-semibold mb-4">
                  Dual Motor Performance & Power
                </h3>
                <ul className="list-disc pl-5 text-gray-600 leading-[28px]">
                  <li>15kW rear motor + 10kW front motor (25kW total output)</li>
                  <li>Direct axle drive reduces driveline drag and noise</li>
                  <li>Constant traction for superior off-road performance</li>
                </ul>
              </div>

              {/* Section 2 */}
              <div>
                <h3 className="text-[20px] font-semibold mb-4">
                  Battery Capacity & Range
                </h3>
                <ul className="list-disc pl-5 text-gray-600 leading-[28px]">
                  <li>26.5kWh lithium iron phosphate battery</li>
                  <li>Estimated driving range up to 160km</li>
                  <li>Better economy than single motor models</li>
                </ul>
              </div>

              {/* Section 3 */}
              <div>
                <h3 className="text-[20px] font-semibold mb-4">
                  Comfort, Safety & Applications
                </h3>
                <ul className="list-disc pl-5 text-gray-600 leading-[28px]">
                  <li>Optional fully enclosed cabin with glass windscreen</li>
                  <li>Heating & air-conditioning (warm & cold)</li>
                  <li>Ideal for tourism, farming & commercial transport</li>
                </ul>
              </div>

            </div>

            {/* Closing line */}
            <p className="text-center text-gray-600 text-[16px] md:text-[18px] leading-[28px] mt-[50px] max-w-[900px] mx-auto">
              The Double Cabin eTuatara combines comfort, safety and go-anywhere capability,
              making it ideal for transporting up to six passengers across demanding terrain.
              This model is truly breaking new ground.
            </p>


            {/* <p className="text-gray-600 text-[18px] font-medium leading-[28px] text-center max-w-[1160px] mx-auto">
              Our newest addition to the eTuarara family is our 6-seat double
              cab UTV, with its dual motors and larger capacity battery, making
              this vehicle a go anywhere people mover. It comes with a very
              innovative dual motor configuration, one on each axle, which
              dispenses with the need for a transmission or drive shafts. This
              significantly reduces driveline drag, resulting in an even quieter
              vehicle. It also reduces even further the maintenance items on the
              vehicle and therefore the costs associated with maintaining these
              items.
              <br />
              <br />
              The dual electric motors comprise a 15kW model on the rear axle
              and a 10kW motor on the front axle, providing a huge 25kW of total
              power, but amazingly, early testing suggests better economy than
              our current 15kW single motor model. We believe that this is
              likely due to the reduced driveline drag but also as a consequence
              of the constant traction provided by the motors working directly
              at the axles.
              <br />
              <br />
              Along with the significantly extra motor power that we have
              brought to the Double Cabin eTuatara is a hugely increased
              capacity 26.5kWh lithium iron phosphate battery. This battery is
              likely to provide a maximum range of up to 160kms., or possibly
              more.
              <br />
              <br />
              The Double Cabin eTuatara has the same go anywhere capability of
              all of our Tuatara models, and can also be fitted with a fully
              enclosed cabin, with fully opening glass windscreen with wiper and
              washer, as well as full or half doors, and can even be fitted with
              air conditioning with both warm and cold capability.
              <br />
              <br />
              Working in the heat or cold? Not a problem, our TU-DC2500-2 model comes with air conditioning with a warm
              or cold function. Create an all-weather enclosed passenger cabin by adding a rear enclosure , full glass
              windscreen, and full doors, making the trip even more comfortable.
              <br />
              <br />
              This vehicle would be ideal for adventure tourism or any
              commercial activity where there is a need to transport up to six
              passengers, in relative comfort and safety, over demanding
              terrain.
              <br />
              <br />
              The Double Cabin eTuatara is definitely breaking new ground.
            </p> */}
          </div>
        </div >
        <div>
          <NZElectricDualModels />
          <NZElectricDualSpec />
        </div>

        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />
        <NZElectricDualFAQ />
        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div >
    </>
  );
};
export default NzElectricDualMotor;
